import React from 'react';
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  IconButton,
  Input,
  Text,
  VStack
} from '@chakra-ui/react';
import { AddIcon, DeleteIcon } from '@chakra-ui/icons';
import CompaniesShowcase from '../CompaniesShowcase';

const CompaniesSection = ({
  isEditing,
  companies,
  entries,
  onFieldChange,
  onAdd,
  onRemove
}) => {
  if (!isEditing) {
    return <CompaniesShowcase companies={companies} heading="Past Companies" />;
  }

  return (
    <Box bg="white" boxShadow="md" borderRadius="md" p={6}>
      <Heading as="h2" size="md" mb={4}>
        Companies
      </Heading>
      <VStack spacing={4} align="stretch">
        {entries.length === 0 && <Text color="gray.500">No companies added yet.</Text>}
        {entries.map((entry, index) => (
          <Box key={entry.id ?? index} borderWidth="1px" borderRadius="md" p={4}>
            <Flex gap={4} flexWrap="wrap" align="flex-end">
              <FormControl flex="1" minW="200px">
                <FormLabel>Company</FormLabel>
                <Input
                  placeholder="Company name"
                  value={entry.name}
                  onChange={(e) => onFieldChange(index, 'name', e.target.value)}
                />
              </FormControl>
              <FormControl flex="1" minW="200px">
                <FormLabel>Website</FormLabel>
                <Input
                  placeholder="example.com"
                  value={entry.website}
                  onChange={(e) => onFieldChange(index, 'website', e.target.value)}
                />
              </FormControl>
              <IconButton
                aria-label="Remove company"
                icon={<DeleteIcon />}
                variant="outline"
                colorScheme="red"
                onClick={() => onRemove(index)}
              />
            </Flex>
          </Box>
        ))}
        <Button onClick={onAdd} leftIcon={<AddIcon />} alignSelf="flex-start" variant="outline" colorScheme="blue">
          Add company
        </Button>
      </VStack>
    </Box>
  );
};

export default CompaniesSection;
